import React from "react";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import { Form, InputSearch } from "@components/ui/Form";
import { ROUTES } from "@root/routes";

const BlogSearch = () => {
  const router = useRouter();
  const { register, handleSubmit } = useForm();

  const onSubmit = handleSubmit((input) => {
    router.push(ROUTES.blog.search({ q: input.q }));
  });

  return (
    <Form onSubmit={onSubmit} className="mt-8 mx-auto max-w-sm">
      <InputSearch name="q" defaultValue={router.query.q} ref={register} />
    </Form>
  );
};

export default BlogSearch;
